export default __webpack_public_path__ + "static/media/c9.29926df4.jpg";